import { render, staticRenderFns } from "./TransactionItemWarning.vue?vue&type=template&id=3aa15e3c&scoped=true"
import script from "./TransactionItemWarning.vue?vue&type=script&lang=ts"
export * from "./TransactionItemWarning.vue?vue&type=script&lang=ts"
import style0 from "./TransactionItemWarning.vue?vue&type=style&index=0&id=3aa15e3c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa15e3c",
  null
  
)

export default component.exports